import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {WissalstoreService} from '../../Services/wissalstore.service';
import {ProductConfiguration} from "../../Models/product-configuration";

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    standalone: false
})
export class FilterComponent implements OnInit, OnChanges {

  @Input() configurations ?: ProductConfiguration [] ;
  @Input () isVisible?:boolean;

  maxPrice: number = 0;
  totalElements: number | null = null;


  constructor(public wissalStoreService: WissalstoreService) { }

  ngOnInit(): void {
  }

  ngOnChanges() {
   // this.getMaxPrice();
    this.totalElements = this.configurations?.length ?? null;
  }

  closeSideNav() {
    this.wissalStoreService.sideNavOpen = false;
  }

  getMaxPrice(){
    // TODO consider retrieving MaxPrice from backend
    if (this.configurations?.length) {
      // const resut = this.products.reduce((a,b) => {return (a.id > b.id) ? a : b});
      this.maxPrice = Math.max(...this.configurations.map(p => p.price ?? 0), 0);
      this.maxPrice = Math.trunc(this.maxPrice);
    }
  }
}
